module.exports = __webpack_public_path__ + "static/media/Accounting Calculator.4d569f0d.svg";